import clienteAxios from "../config/axios";

export async function getProductsByTDocNroFor(tDocCodFor ,tDocNroFor) {
    return clienteAxios.get(`/productBytDocNroFor/${tDocCodFor}/${tDocNroFor}`);
}

